import { AccessTokenSlice } from "../redux/reducers/reducer";

export const SelectAccessTokenEndpoint = () => {

}

export const res_modifiers_config = {
  getAccessToken: (res) => {
    
    return res;
  }
};